import {ReactElement} from 'react';

import {ListItemIcon, MenuItem, Typography} from '@mui/material';

import {getAppHeaderMenuItemConfig, getAppHeaderMenuItemSx} from '../../../../layouts/theme/ThemeHelpers';

interface Props {
  label: string;
  onClick: () => void;
  icon: ReactElement;
}

export const AppHeaderMenuItem = ({label, onClick, icon}: Props) => {
  const menuItem = getAppHeaderMenuItemConfig();
  const itemSx = getAppHeaderMenuItemSx();

  return (
    <MenuItem onClick={onClick} sx={itemSx}>
      <ListItemIcon
        sx={{
          minWidth: menuItem.iconMinWidth,
          color: menuItem.color,
        }}
      >
        {icon}
      </ListItemIcon>
      <Typography variant='body2' sx={{fontWeight: menuItem.fontWeight}}>
        {label}
      </Typography>
    </MenuItem>
  );
};
